export { MiniTitle } from './miniTitle/miniTitle';
export { DateView } from './dateView/dateView';
export {Tg} from './mediaLinks/tg'
export {Rutube} from './mediaLinks/rutube'